// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import RecordingsPage from '@/pages/recordings';
// ----------------------------------------------------------------

/**
 * The Route component is a file route that is used to render the RecordingsPage component.
 * This is a route setup for '/recordings/' route.
 */
export const Route = createFileRoute('/_authenticated-layout/recordings/')({
  component: RecordingsPage,
});
